<template>
    <div id="tasks-tab">
      <v-loading :isLoading="loading"></v-loading>
       <div class="panel-default" v-if="!loading">
        <div class="panel-body">
          <div class="row">
            <div class="col-12">
              <div class="row background-white">
                <div class="col-12">
                  <div class="panel-content-inner w-full">
                    <div class="row d-flex justify-content-around">
                      <div class="jobs-desc text-center">
                        <p class="number">{{ statusCounts.toBeAssigned }}</p>
                        <span class="desc desc-be-assigned">{{ getStatusName(1) ? getStatusName(1) :  $t('calendar.jobs.to_be_assigned') }}</span>
                      </div>
                      <div class="jobs-desc text-center">
                        <p class="number">{{ statusCounts.assigned }}</p>
                        <span class="desc desc-assigned">{{ getStatusName(2) ? getStatusName(2) :  $t('calendar.jobs.assigned') }}</span>
                      </div>
                      <div class="jobs-desc text-center">
                        <p class="number">{{ statusCounts.done }}</p>
                        <span class="desc desc-done">{{ getStatusName(3) ? getStatusName(3) :  $t('calendar.jobs.done') }}</span>
                      </div>
                      <div class="jobs-desc text-center">
                        <p class="number">{{ statusCounts.inProgress }}</p>
                        <span class="desc desc-cleaning">{{getStatusName(4) ? getStatusName(4) :  $t('calendar.jobs.in_progress')}}</span>
                      </div>
                      <div class="jobs-desc text-center">
                        <p class="number">{{ statusCounts.late }}</p>
                        <span class="desc desc-cancelled">{{ getStatusName(5) ? getStatusName(5) :  $t('calendar.jobs.late') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-t-15 background-white">
                <div class="col-12">
                  <div class="panel-content-inner w-full">
                    <div class="row justify-content-between m-t-15">
                      <div class="col-auto">
                        <div class="row">
                          <div class="col-8">
                            <div class="form-group form-material">
                              <select class="form-control" v-model="selectedMember">
                                <option disabled selected value="selected">{{$t('calendar.jobs.assign_to')}}</option>
                                <option :value="null">Unassigned</option>
                                <option v-for="member in members" :value="member.id">{{ `${member.first_name} ${member.last_name}` }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-4 m-t-5">
                            <div class="form-group form-material">
                              <button
                                class="btn btn-primary waves-effect waves-classic btn-save apply-btn"
                                @click.prevent="assignCheckedTasksToMember()"
                                :disabled="!isAtLeastOneTaskChecked"
                              >
                                {{ $t('button.apply') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 m-t-5">
                        <div class="row">
                          <div class="col-11 date-filter">
                            <span class="pull-right">
                              <date-picker
                                :shortcuts="shortcuts"
                                v-model="date"
                                range
                                type="date"
                                width="225"
                                :clearable="false"
                                format="MMM DD, YYYY"
                                confirm
                                lang="en"
                              >
                              </date-picker>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-t-15 background-white">
                <div class="col-12">
                  <div class="panel-content-inner w-full">
                    <div class="row">
                      <div id="tasks-table">
                        <div class="">
                          <h2>{{$t('calendar.tasks.task_management')}}</h2>
                          <table v-if="tasks.length > 0" class="tasks-table-sizes row-link table table-responsive">
                            <thead>
                            <tr>
                              <th class="task-detail"><div><input type="checkbox" @click="checkOrUncheckTasks" v-model="allTasksAreChecked"></div></th>
                              <th class="task-status"><span>{{ $t('calendar.tasks.status_title') }}</span></th>
                              <th class="task-title"><span>{{ $t('calendar.tasks.title') }}</span></th>
                              <th class="task-rental"><span>{{ $t('calendar.tasks.rental') }}</span></th>
                              <th class="task-due-date"><span>{{ $t('calendar.tasks.due_date') }}</span></th>
                              <th class="task-assigned-to"><span>{{ $t('calendar.tasks.assigned_to') }}</span></th>
                              <th class="task-actions"><span>{{ $t('calendar.tasks.actions') }}</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="task in tasks">
                              <td class="task-id task-detail"><div id="task-id-td"><input type="checkbox" v-model="task.checked" @change="checkCheckedTasks"></div></td>
                              <td class="task-action statuses" @click.prevent="editTask(task)">
                                <div class="row d-flex justify-content-center">
                                  <div class="col-6">
                                    <span class="status-circle" :class="getClass(task.assigned_status)">{{ getStatusName(task.assigned_status) }}</span>
                                  </div>
                                </div>
                              </td>
                              <td class="task-rental task-detail" @click.prevent="editTask(task)"><div>{{task.title}}</div></td>
                              <td class="task-checkin task-detail" @click.prevent="editTask(task)"><div>{{ task.rental.name }}</div></td>
                              <td class="task-nights task-detail" @click.prevent="editTask(task)">
                                <div>
                                  {{ getDueDateFormatted(task.due_date) }}
                                </div>
                              </td>
                              <td class="task-channel team-members" @click.prevent="editTask(task)">
                                <div>
                                  {{ getMemberName(task.assigned_to) }}
                                </div>
                              </td>
                              <td class="task-actions">
                                <div class="row justify-content-center action-padding pos-rel">
                                  <div class="col-6 column-padding">
                                    <div class="row action-padding">
                                      <div class="col-6">
                                        <div class="dropdown padding-none dropup">
                                          <span class="action-icons plus-icon dropdown-toggle " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-bars"></i></span>
                                          <div class="dropdown-menu dropdown-menu-right add-members">
                                            <ul class="add-member-list">
                                              <li class="add-member-list-item" v-for="status in statuses"
                                                  :class="task.assigned_status === status.id ? 'list-selected' : ''"
                                                  @click.prevent="changeAssignStatus(task, status.id)"
                                              >{{ status.name }}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-6">
                                        <div class="dropdown padding-none dropup">
                                          <span class="action-icons plus-icon dropdown-toggle " data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"><i class="far fa-plus"></i></span>
                                          <div class="dropdown-menu dropdown-menu-right add-members">
                                            <ul class="add-member-list">
                                              <li class="add-member-list-item" v-if="task.assigned_to" @click.prevent="addOrChangeTeamMember(task)">Unassign</li>
                                              <li class="add-member-list-item"
                                                  :class="task.assigned_to === member.id ? 'list-selected' : ''"
                                                  @click.prevent="addOrChangeTeamMember(task, member.id)"
                                                  v-for="(member) in members">
                                                {{ `${member.first_name} ${member.last_name}` }}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <div v-else slot="body" class="d-flex justify-content-center mb-10">
                            <div class="list-rental-empty mt-0">
                              <div>
                                <img src="/static/assets/images/SuperHote_icons/rent.png" >
                                <span class="no-result">{{ $t('calendar.tasks.no_tasks') }}</span>
                                <button  class="btn btn-setup " type="submit" @click.prevent="createTask">{{ $t("button.create") }}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-create-task
        :members="members"
        :rentals="rentals"
        :editedTask="editedTask"
        @getTasks="getTasks"
        @decreaseCount="decreaseCount"
        ref="createTask"
      />
    </div>
</template>

<script>
import mixin from "../../../../mixins/mixin";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import teamMemberService from '../../../../services/team_member';
import taskService from '../../../../services/task';
import rentalService from '../../../../services/rental'

export default {
name: "TaskLists",
  data() {
    return {
      tasks: [],
      statuses: [],
      members: [],
      statusCounts: {
        toBeAssigned: 0,
        assigned: 0,
        done: 0,
        inProgress: 0,
        late: 0,
      },
      selectedMember: '',
      isAtLeastOneTaskChecked: false,
      allTasksAreChecked: false,
      loading: false,
      shortcuts: [],
      date: [ moment().format('YYYY-MM-DD'), moment().add(1, 'year').format('YYYY-MM-DD') ],
      editedTask: {},
      rentals: []
    }
  },
  components: {
    VCreateTask: require('./CreateTask'),
    DatePicker,
    VLoading: require('components/loading/loading.vue'),
  },
  props: [
    'checkedRentals'
  ],
  mixins: [mixin],
  async mounted() {
    teamMemberService.get(this);
    taskService.getStatuses(this);
    this.getRentals();
    await this.getTasks();
  },
  methods: {
    getTasks() {
      this.loading = true;
      let start = null;
      let end = null;
      let rentals = [];
      if (this.date) {
        start = moment(this.date[0]).format('YYYY-MM-DD');
        end = moment(this.date[1]).format('YYYY-MM-DD');
      }
      if (Object.keys(this.checkedRentals).length > 0) {
        rentals = Object.keys(this.checkedRentals).filter(key => this.checkedRentals[key] === true);
      }
      taskService.get(this, start, end, rentals);
    },
    getClass(id) {
      let assignClass = '';
      switch (id) {
        case 1:
          assignClass = 'to-be-assigned';
          break;
        case 2:
          assignClass = 'assigned';
          break;
        case 3:
          assignClass = 'done';
          break;
        case 6:
          assignClass = 'in-progress';
          break;
        case 7:
          assignClass = 'late';
          break;
      }
      return assignClass;
    },
    getStatusName(id) {
      const status = this.statuses.find(status => status.id === id);
      if (status) {
        return status.name;
      }
    },
    getMemberName(id) {
      const member = this.members.find(member => member.id === id);
      if (member) {
        return `${member.first_name} ${member.last_name}`;
      }
    },
    async changeAssignStatus(task, id) {
      const oldStatus = task.assigned_status;
      task.assigned_status = id;
      await taskService.update(this, task, task.id);
      await this.getTasks();
      this.calculateCount(task.assigned_status, oldStatus)
    },
    async addOrChangeTeamMember(task, memberId = null) {
      task.assigned_to = memberId;
      await taskService.update(this, task, task.id);
      await this.getTasks();
    },
    createTask() {
      this.$refs.createTask.editTask = false;
      this.$refs.createTask.newTask = { ...this.$refs.createTask.defaultNewTask};
      this.$refs.createTask.assigned_to_type = null;
      this.openModal('#create-task-modal');
    },
    exportTasks() {

    },
    getDueDateFormatted(date) {
      return moment(date).format('ddd DD MMMM . YYYY')
    },
    calculateCounts(oldTasks) {
      if (this.tasks) {
        this.tasks.map(task => {
          let oldTask = oldTasks.find(oldTask => oldTask.id === task.id);
          let oldStatus = null;
          if (oldTask) {
            oldStatus = oldTask.assigned_status;
          }
          this.calculateCount(task.assigned_status, oldStatus);
        });
      }

      if (oldTasks) {
        oldTasks.forEach(task => {
          let oldTask = this.tasks.find(newTask => newTask.id === task.id);
          if (!oldTask) {
            this.decreaseCount(task.assigned_status);
          }
        })
      }
    },
    calculateCount(status, oldStatus = null) {
      switch (status) {
        case 1:
          this.statusCounts.toBeAssigned++;
          break;
        case 2:
          this.statusCounts.assigned++;
          break;
        case 3:
          this.statusCounts.done++;
          break;
        case 6:
          this.statusCounts.inProgress++;
          break;
        case 7:
          this.statusCounts.late++;
          break;
      }

      if (oldStatus) {
        this.decreaseCount(oldStatus);
      }
    },
    decreaseCount(status) {
      switch (status) {
        case 1:
          this.statusCounts.toBeAssigned--;
          break;
        case 2:
          this.statusCounts.assigned--;
          break;
        case 3:
          this.statusCounts.done--;
          break;
        case 6:
          this.statusCounts.inProgress--;
          break;
        case 7:
          this.statusCounts.late--;
          break;
      }
    },
    async assignCheckedTasksToMember() {
      if (this.selectedMember === '') {
        toastr.error(this.$t('calendar.tasks.select_member'));
        return;
      }

      this.loading = true;
      const data = [];
      this.tasks.map(task => {
        if (task.checked) {
          task.assigned_to = this.selectedMember
          task.checked = false;
          data.push({
            id: task.id,
            assigned_to: task.assigned_to
          });
        }
      });
      this.selectedMember = '';
      this.allTasksAreChecked = false;
      this.isAtLeastOneTaskChecked = false;
      await taskService.assignMemberToCheckedTasks(this, data);
      await this.getTasks();
    },
    checkOrUncheckTasks() {
      this.tasks.map(task => task.checked = !this.allTasksAreChecked);
      this.isAtLeastOneTaskChecked = !this.allTasksAreChecked;
    },
    checkCheckedTasks() {
      const checkedTasks = this.tasks.filter(task => task.checked === true);
      this.isAtLeastOneTaskChecked = false;
      this.allTasksAreChecked = false;

      if (checkedTasks.length > 0) {
        this.isAtLeastOneTaskChecked = true;
      }

      if (this.tasks.length === checkedTasks.length) {
        this.allTasksAreChecked = true;
      }
    },
    editTask(task) {
      this.editedTask = {...task};
      this.openModal('#create-task-modal');
    },
    getRentals() {
      rentalService.getAll(this, true);
    },
  },
  watch: {
    'tasks': function (tasks, oldTasks) {
      if (tasks) {
        this.calculateCounts(oldTasks);
      }
    },
    'date': function () {
     this.getTasks();
    }
  }
}
</script>



// WEBPACK FOOTER //
// TaskLists.vue?c4d2f516